import React, { Component } from 'react';
import { connect } from 'react-redux';

import { reduxForm } from 'redux-form';

import Moment from 'moment';

import { formatPhone, formatBoolean, humanizeSymbol } from 'helpers/Formatter';
import { deepDiver } from 'helpers/utilities';
import deepDiff from 'return-deep-diff';

import TableHeader from 'components/shared/TableHeader';
import ReviewField from 'components/shared/ReviewField';

import { PAGES } from 'components/landlord_app/properties/AddProperty';
import { ServicesAndUtilitiesFields } from 'components/landlord_app/applications/components/lease_creator/servicesAndUtilitiesWizardPage';

import { localize } from 'react-localize-redux';
import TenantResidentVerbiageHelper from 'components/shared/TenantResidentVerbiageHelper';

class ReviewPropertyForm extends Component {
  constructor(props) {
    super(props);
    this.state = { last_invited_time: null };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const diff = deepDiff(this.props.initialValues, nextProps.initialValues);
    if (diff) {
      this.forceUpdate();
    }
  }

  render() {
    const { handleSubmit, formValues } = this.props;

    if (!formValues) return null;

    return (
      <form
        onSubmit={handleSubmit}
        id="form_field"
        encType="multipart/form-data"
        className="reviewForm"
      >
        {this.renderSiteName(formValues)}
        {this.renderAddress(formValues)}
        {this.renderImportantDetails(formValues)}
        {this.renderOwner(formValues)}
        {this.renderPropertyDescription(formValues)}
        {this.renderAncillaryItems(formValues)}
        {this.renderAgents(formValues)}
        {this.renderServicesAndUtilities()}
        {this.renderFloorPlans(formValues)}
        {this.renderUnits(formValues)}
        {this.renderRooms(formValues)}
        {this.renderContacts(formValues)}
        {this.renderPropertyFAQs(formValues)}
        {this.renderPreShowingInstructions(formValues)}
        {this.renderWelcomeVideoLink(formValues)}
        {this.renderCreditCheck(formValues)}
      </form>
    );
  }
  renderSiteName(formValues) {
    return (
      <div>
        <TableHeader name="Property Site" />

        <div className="row" style={{ marginTop: '15px' }}>
          <div className="col-xs-6" style={{ textAlign: 'center', zIndex: '1000' }}>
            <ReviewField title="Name" value={formValues.site_name} />
          </div>
        </div>
      </div>
    );
  }

  renderAddress(formValues) {
    const editable = formValues.editable === 'true';
    return (
      <div>
        <TableHeader
          name="Property Address"
          onEdit={editable ? () => this.props.goToPage(PAGES.PROPERTY_ADDRESS) : undefined}
        />

        <div className="row" style={{ marginTop: '15px' }}>
          <div className="col-xs-6" style={{ textAlign: 'center', zIndex: '1000' }}>
            <ReviewField title="Street" value={formValues.street} textTransform="none" />
          </div>

          <div className="col-sm-6">
            <ReviewField
              title="Property Type"
              value={formValues.property_type}
              format={property_type => property_type.replace('_', ' ')}
            />
          </div>

          <div className="col-sm-6" style={{ textAlign: 'center' }}>
            <ReviewField title="City" value={formValues.city} />
          </div>

          <div className="col-sm-6" style={{ textAlign: 'center' }}>
            <ReviewField title="Province" value={formValues.province} />
          </div>

          <div className="col-sm-6" style={{ textAlign: 'center' }}>
            <ReviewField title="Postal Code" value={formValues.postal_code} />
          </div>

          <div className="col-sm-6" style={{ textAlign: 'center' }}>
            <ReviewField title="Country" value={formValues.country} />
          </div>
        </div>
      </div>
    );
  }

  renderImportantDetails(formValues) {
    const editable = formValues.editable === 'true';
    return (
      <div>
        <TableHeader
          name="Important Details"
          onEdit={editable ? () => this.props.goToPage(PAGES.IMPORTANT_DETAILS) : undefined}
        />

        <div className="row" style={{ marginTop: '15px' }}>
          <div className="col-sm-6">
            <ReviewField
              title="Are you a third-party manager on this property?"
              value={formValues.third_party_manager}
              format={formatBoolean}
            />
          </div>

          <div className="col-sm-6">
            <ReviewField
              title="Do you collect a security deposit?"
              value={formValues.uses_security_deposit}
              format={formatBoolean}
            />
          </div>
        </div>
      </div>
    );
  }

  renderOwner(formValues) {
    if (formValues.third_party_manager === 'false') return null;

    const editable = formValues.editable === 'true';

    if (!formValues.owners || !formValues.owners.length) {
      return (
        <div>
          <TableHeader
            name="Owner Details"
            onEdit={editable ? () => this.props.goToPage(PAGES.OWNER_DETAILS) : undefined}
          />

          <div className="row">
            <div className="col-xs-12">
              <p style={{ fontSize: '12px', color: 'rgba(0, 0, 0, 0.4)' }}>
                No owner added to property
              </p>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div>
        <TableHeader
          name="Owner Details"
          onEdit={editable ? () => this.props.goToPage(PAGES.OWNER_DETAILS) : undefined}
        />

        {formValues.owners.map(owner => (
          <div>
            <div className="row" style={{ marginTop: '15px' }}>
              <div className="col-sm-6">
                <ReviewField title="Name" value={`${owner.first_name} ${owner.last_name}`} />
              </div>

              <div className="col-sm-6">
                <ReviewField title="Email" value={owner.email} />
              </div>
            </div>

            <div className="row" style={{ marginTop: '15px' }}>
              {owner.confirmed_at ? (
                <div className="col-sm-12">
                  <p style={{ fontSize: '12px', color: 'rgba(0, 0, 0, 0.4)' }}>
                    Account confirmed on {owner.confirmed_at}
                  </p>
                </div>
              ) : (
                <div>
                  <div className="col-sm-6">
                    <p style={{ fontSize: '12px', color: 'rgba(0, 0, 0, 0.4)' }}>
                      Owner not yet signed up with yuhu.
                    </p>
                    {owner.invitation_sent_at ? (
                      <p style={{ fontSize: '12px', color: 'rgba(0, 0, 0, 0.4)' }}>
                        Invitation last sent: {owner.invitation_sent_at}
                      </p>
                    ) : (
                      <p style={{ fontSize: '12px', color: 'rgba(0, 0, 0, 0.4)' }}>
                        An invitation has not been sent.
                      </p>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    );
  }

  renderPropertyDescription(formValues) {
    const editable = formValues.editable === 'true';

    return (
      <div>
        <TableHeader
          name="Property Details and Preferences"
          onEdit={editable ? () => this.props.goToPage(PAGES.PROPERTY_DETAILS) : undefined}
        />

        <div className="row" style={{ marginTop: '15px' }}>
          <div className="col-sm-12">
            <ReviewField
              title="Property Description"
              value={formValues.about}
              valueStyle={{ minHeight: '40px' }}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-sm-4">
            <ReviewField title="Pets" value={formValues.pets} />
          </div>

          <div className="col-sm-4">
            <ReviewField title="Utilities" value={formValues.utilities} />
          </div>
        </div>
      </div>
    );
  }

  renderAgents(formValues) {
    const editable = formValues.editable === 'true';

    return (
      <div>
        <TableHeader
          name="Assigned Leasing Agents"
          onEdit={editable ? () => this.props.goToPage(PAGES.LEASING_AGENTS) : undefined}
        />

        <div className="row" style={{ marginTop: '15px' }}>
          {formValues.leasing_agents.map((agent, index) => (
            <div key={index} className="col-sm-6">
              <ReviewField title={`Agent ${index + 1}`} value={agent.label} />
            </div>
          ))}
        </div>
      </div>
    );
  }

  renderServicesAndUtilities() {
    return (
      <div>
        <TableHeader
          name={this.props.translate('services_and_utilities')}
          onEdit={() => this.props.goToPage(PAGES.SERVICES_AND_UTILITIES)}
        />

        <div className="row">
          <ServicesAndUtilitiesFields formName={'add_property'} isReviewMode={true} />
        </div>
      </div>
    );
  }

  renderAncillaryItems(formValues) {
    const editable = formValues.ancillary_items_editable === 'true';
    if (!formValues.ancillary_items || formValues.ancillary_items.length === 0) {
      return (
        <div>
          <TableHeader
            name="Ancillary Items"
            onEdit={editable ? () => this.props.goToPage(PAGES.ANCILLARY_ITEMS) : undefined}
          />

          <div className="row">
            <div className="col-xs-12">
              <p style={{ fontSize: '12px', color: 'rgba(0, 0, 0, 0.4)' }}>
                No ancillary items added to property.
              </p>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div>
        <TableHeader
          name="Ancillary Items"
          onEdit={editable ? () => this.props.goToPage(PAGES.ANCILLARY_ITEMS) : undefined}
        />

        <div className="row" style={{ marginTop: '15px' }}>
          {formValues.ancillary_items.map((ancillaryItem, index) => (
            <div key={index}>
              <div className="row">
                <div className="col-sm-12">
                  <h4 style={{ lineHeight: '26px' }}>Ancillary Item {index + 1}</h4>
                </div>
              </div>

              <div className="row">
                <div className="col-sm-6" style={{ textAlign: 'center' }}>
                  <ReviewField title="Ancillary Item Name" value={ancillaryItem.item_type} />
                </div>

                <div className="col-sm-6">
                  <ReviewField title="Monthly Market Rent" value={ancillaryItem.market_amount} />
                </div>
              </div>

              <div className="row">
                <div className="col-sm-6">
                  <ReviewField title="Deposit" value={ancillaryItem.market_deposit_amount} />
                </div>

                {ancillaryItem.asset_number !== undefined && (
                  <div className="col-sm-6" style={{ textAlign: 'center' }}>
                    <ReviewField title="Identification Number" value={ancillaryItem.asset_number} />
                  </div>
                )}
              </div>

              <div className="row">
                <div className="col-sm-6">
                  <ReviewField
                    title="Is this an asset?"
                    value={ancillaryItem.is_asset}
                    format={formatBoolean}
                  />
                </div>

                <div className="col-sm-6">
                  <ReviewField
                    title="Is available to rent?"
                    value={ancillaryItem.is_rentable}
                    format={formatBoolean}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  renderUnits(formValues) {
    const units = formValues.units;
    const singleUnit = formValues && formValues.units.length === 1;
    const unitOrPropertyText = singleUnit ? 'Property' : 'Unit';
    const editable = formValues.editable === 'true';

    return (
      <div>
        <TableHeader
          name="Units"
          onEdit={editable ? () => this.props.goToPage(PAGES.UNITS) : undefined}
        />

        <div className="row" style={{ marginTop: '15px' }}>
          {units.map((unit, index) => (
            <div key={index}>
              <div className="row">
                <div className="col-sm-12">
                  <h4 style={{ lineHeight: '26px' }}>Unit {unit.unit_number}</h4>
                </div>
              </div>

              <div className="row">
                {unitOrPropertyText === 'Unit' && (
                  <div className="col-sm-6" style={{ textAlign: 'center' }}>
                    <ReviewField title={`${unitOrPropertyText} Number`} value={unit.unit_number} />
                  </div>
                )}

                <div className="col-sm-6" style={{ textAlign: 'center' }}>
                  <ReviewField
                    title={`${unitOrPropertyText} Size (in sq. ft.)`}
                    value={unit.sq_footage}
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-sm-6">
                  <ReviewField title="Monthly Rent" value={unit.market_rent} />
                </div>

                <div className="col-sm-6">
                  <ReviewField
                    title={unit.beds_in_numbers ? 'Number of Bedrooms' : 'Unit Type'}
                    value={unit.beds_in_numbers || unit.friendly_unit_type}
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-sm-6">
                  <ReviewField
                    title="Accessible?"
                    value={unit.is_accessible}
                    format={formatBoolean}
                  />
                  <ReviewField
                    title="Is available to rent?"
                    value={unit.is_rentable}
                    format={formatBoolean}
                  />
                  <ReviewField title="Is there a den?" value={unit.den} format={formatBoolean} />
                  <ReviewField title="Furnished" value={unit.furnished} format={formatBoolean} />
                </div>

                <div className="col-sm-6">
                  <ReviewField title="Number of Bathrooms" value={unit.number_of_baths} />
                  <ReviewField title="Smoking" value={unit.smoking} format={formatBoolean} />
                  {unit.rooms && <ReviewField title="Rooms associated" value={unit.rooms.length} />}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  renderRooms(formValues) {
    const rooms = formValues.rooms;
    const editable = true;

    if (rooms === undefined || rooms.length === 0) {
      return (
        <div>
          <TableHeader
            name="Property Owned Rooms"
            onEdit={editable ? () => this.props.goToPage(PAGES.ROOMS) : undefined}
          />

          <div className="row">
            <div className="col-xs-12">
              <p style={{ fontSize: '12px', color: 'rgba(0, 0, 0, 0.4)' }}>
                No rooms have been added to the property.
              </p>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div>
        <TableHeader
          name="Property Owned Rooms"
          onEdit={editable ? () => this.props.goToPage(PAGES.ROOMS) : undefined}
        />

        <div className="row" style={{ marginTop: '15px' }}>
          {rooms.map((room, index) => (
            <div key={`rooms_review_${index}`}>
              <div className="row">
                <div className="col-sm-12">
                  <h4 style={{ lineHeight: '26px' }}>{room.name}</h4>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <ReviewField title="type" value={room.room_type} />
                </div>

                {room.rooms &&
                  room.rooms.length > 0 && (
                    <div className="col-sm-6">
                      <ReviewField title="Internal Rooms" value={room.rooms.length} />
                    </div>
                  )}
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  renderFloorPlans(formValues) {
    const floorPlans = formValues.floor_plans;
    const editable = formValues.editable === 'true';

    return (
      <div>
        <TableHeader
          name="Floor Plans"
          onEdit={editable ? () => this.props.goToPage(PAGES.FLOOR_PLANS) : undefined}
        />

        <div className="row" style={{ marginTop: '15px' }}>
          {(!floorPlans || floorPlans.length === 0) && (
            <div className="row">
              <div className="col-sm-8">
                <p style={{ color: 'rgba(0, 0, 0, 0.3)' }}>No floor plans provided.</p>
              </div>
            </div>
          )}

          {floorPlans &&
            floorPlans.map((floorPlan, index) => (
              <div className="row" key={index}>
                <div className="row">
                  <div className="col-sm-12">
                    <h4 style={{ lineHeight: '26px' }}>Floor Plan #{index + 1}</h4>
                  </div>
                </div>

                <div className="col-sm-6">
                  <ReviewField title="Floor Plan Name" value={floorPlan.name} />
                </div>

                <div className="col-sm-6">
                  <ReviewField title="Description" value={floorPlan.description} />
                </div>
              </div>
            ))}
        </div>
      </div>
    );
  }

  renderContacts(formValues) {
    const contactCards = formValues.contact_cards;
    const editable = true;

    return (
      <div>
        <TableHeader
          name="Contact Details"
          onEdit={editable ? () => this.props.goToPage(PAGES.CONTACT_INFORMATION) : undefined}
        />

        <div className="row" style={{ marginTop: '15px' }}>
          {(!contactCards || contactCards.length === 0) && (
            <div className="row">
              <div className="col-sm-8">
                <p style={{ color: 'rgba(0, 0, 0, 0.3)' }}>No contact details provided.</p>
              </div>
            </div>
          )}

          {contactCards &&
            contactCards.map((contactCard, index) => (
              <div key={index}>
                <div className="row">
                  <div className="col-sm-12">
                    <h4 style={{ lineHeight: '26px' }}>Contact Details #{index + 1}</h4>
                  </div>
                </div>

                <div className="row" style={{ marginBottom: '25px' }}>
                  <div className="row">
                    <div className="col-xs-12">
                      <ReviewField title="Contact Type" value={contactCard.contact_card_type} />
                    </div>

                    <div className="col-sm-6" style={{ textAlign: 'center' }}>
                      <ReviewField title="Email" value={contactCard.email} />
                    </div>

                    <div
                      className={
                        contactCard.phone_number_extension ? 'col-sm-4 col-xs-8' : 'col-sm-6'
                      }
                      style={{ textAlign: 'center' }}
                    >
                      <ReviewField
                        title="Phone Number"
                        value={formatPhone(contactCard.phone_number)}
                      />
                    </div>
                    {contactCard.phone_number_extension && (
                      <div className={'col-sm-2 col-xs-4'} style={{ textAlign: 'center' }}>
                        <ReviewField title="Ext." value={contactCard.phone_number_extension} />
                      </div>
                    )}
                  </div>

                  {contactCard &&
                    contactCard.contact_card_type === 'office' && (
                      <div className="row">
                        <div className="row">
                          <div className="col-sm-12">
                            <h5 style={{ lineHeight: '26px', color: 'rgba(0, 0, 0, 0.3)' }}>
                              Available Hours
                            </h5>
                          </div>
                        </div>

                        <div className="col-xs-12" style={{ padding: 0, marginTop: '-12px' }}>
                          <div className="col-sm-6">
                            <ReviewField
                              title="Available From"
                              value={contactCard.business_hours_start}
                              format={dateObj => Moment(dateObj).format('h:MM A')}
                            />
                          </div>

                          <div className="col-sm-6">
                            <ReviewField
                              title="Available To"
                              value={contactCard.business_hours_end}
                              format={dateObj => Moment(dateObj).format('h:MM A')}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                </div>
              </div>
            ))}
        </div>
      </div>
    );
  }

  renderPropertyFAQs(formValues) {
    return (
      <div>
        <TableHeader
          name="Property FAQs"
          onEdit={() => this.props.goToPage(PAGES.PRESCREENING_MESSAGE)}
        />

        <div className="row" style={{ marginTop: '15px' }}>
          <div className="col-xs-12">
            <ReviewField
              title={
                <span>
                  If you would like to provide frequently asked questions and answers to your{' '}
                  <TenantResidentVerbiageHelper />s (accessible on the tenant portal), provide them
                  below.
                </span>
              }
              value={formValues.property_faq}
              titleStyle={{ fontSize: '12px' }}
            />
          </div>
        </div>
      </div>
    );
  }

  renderWelcomeVideoLink(formValues) {
    return (
      <div>
        <TableHeader
          name={this.props.translate('landlordPortal.properties.welcomeVideoTitle')}
          onEdit={() => this.props.goToPage(PAGES.PRESCREENING_MESSAGE)}
        />

        <div className="row" style={{ marginTop: '15px' }}>
          <div className="col-xs-12">
            <ReviewField
              title={
                <span>{this.props.translate('landlordPortal.properties.welcomeVideoInfo')}</span>
              }
              value={formValues.welcome_video_link}
              titleStyle={{ fontSize: '12px' }}
            />
          </div>
        </div>
      </div>
    );
  }

  renderCreditCheck(formValues) {
    return (
      <div>
        <TableHeader
          name={this.props.translate('landlordPortal.properties.creditCheckPermissions')}
          onEdit={() => this.props.goToPage(PAGES.PRESCREENING_MESSAGE)}
        />

        <div className="row" style={{ marginTop: '15px' }}>
          <div className="col-xs-12">
            <ReviewField
              title={
                <span>
                  {this.props.translate('landlordPortal.properties.creditCheckPermissionsInfo')}
                </span>
              }
              value={humanizeSymbol(formValues.credit_check_permissions)}
              titleStyle={{ fontSize: '12px' }}
            />
          </div>
        </div>
      </div>
    );
  }

  renderPreShowingInstructions(formValues) {
    const editable = true;

    return (
      <div>
        <TableHeader
          name="Pre-showing Instructions"
          onEdit={editable ? () => this.props.goToPage(PAGES.PRESCREENING_MESSAGE) : undefined}
        />

        <div className="row" style={{ marginTop: '15px' }}>
          <div className="col-xs-12">
            <ReviewField
              title="If you would like to provide pre-showing instructions to be sent to your prospects prior to a booked appointment, provide them below."
              value={formValues.pre_showing_instructions}
              titleStyle={{ fontSize: '12px' }}
            />
          </div>
        </div>
      </div>
    );
  }
}

ReviewPropertyForm = reduxForm({
  form: 'add_property',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  enableReinitialize: true,
})(ReviewPropertyForm);

ReviewPropertyForm = connect(store => ({
  initialValues: store.landlordProperties.property,
  formValues: deepDiver(store, 'form.add_property.values'),
}))(ReviewPropertyForm);

export default localize()(ReviewPropertyForm);
